import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core'
import {AuthService} from "../../../services/auth.service";

@Component({
  selector: 'app-st-current-user-navicon',
  templateUrl: './st-current-user-navicon.component.html',
  styles: ['.dropdown-menu.show { min-width: 200px; }'],
  standalone: false
})
export class StCurrentUserNaviconComponent implements OnInit {

  userDisplayName?: string;
  userPositionTitle?: string;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    /*
    this.authService.getUserInfo().then((user: any) => {
      this.userDisplayName = user.name;
    });
    const roles: string[] = [];
    //const roles = this.authService.getRealmRoles();
    if (roles?.includes('USER')) {
      this.userPositionTitle = 'User';
    } else if (roles?.includes('HELPDESK')) {
      this.userPositionTitle = 'Help Desk';
    }*/
  }

  goToProfile() {
    //this.authService.goToAccountPage();
  }

  logout() {
    //this.authService.logout();
  }


}
